<template>
    <div class="info">
        <div class="info-content">
            <div class="success-swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <!--<img src="../../static/images/case_detail.png" alt="">-->
                        <div v-html="casedetail.content"></div>
                    </div>
                </div>
            </div>
            <div class="end">-&nbsp;THE&nbsp;END&nbsp;-</div>
            <!--<div class="swiper-controller">
                <div class="success-swiper-prev"><i class="iconfont icon-jiantouzuo"></i>上一个</div>
                <span>|</span>
                <div class="success-swiper-next">下一个<i class="iconfont icon-icon_arrow_right"></i></div>
            </div>-->
            <br>
            <i class="back iconfont icon-fanhui" @click="back"></i>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper'
export default {
    name: 'Info',
    props:{
        casedetail:Object
    },
    data () {
        return {
        }
    },
    mounted () {
        this.successSwiper();
    },
    methods:{
        successSwiper () {
            var swiper = new Swiper('.success-swiper-container',{
                // navigation: {
                //     nextEl: '.success-swiper-next',
                //     prevEl: '.success-swiper-prev',
                // }
            });
        },
        back(){
            this.$router.push('/cases');
        },
        imgShow (str) {
            var reg = new RegExp(/(src=")([^"]*")/g)
            var arr = reg.exec(str)
            if(!arr){
                return str
            }
            else{
                return str.replace(reg,"$1https://guanwang.wsandos.com$2")
            }
        }
    }
}



</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    .swiper-slide >>> img
        width: 100%
    .info
        width: 100%
        max-width: 1920px 
        min-width: 1440px
        margin: 0 auto
        .info-content
            width: 60%
            text-align: center
            margin: 0 auto
            font-size: 14px
            .success-swiper-container
                overflow: hidden
                width: 100%
                img
                    width: 100%
            .end
                padding-bottom: 21px
                color: #333
                border-bottom: 1px solid #d6d6d6
            .swiper-controller
                display: inline-block
                background: #000
                color: #fff
                margin: 2em 0 4em
                >div
                    display: inline-block
                    padding: 1.2em 1.5em
                    i
                        margin: 0 0.3em
                        font-size: 14px
            .back
                display: inline-block
                width: 50px
                height: 50px
                line-height: 50px
                font-size: 26px
                background: #ededed
                border-radius: 30px
                margin-bottom: 125px
                margin-top: 55px
                color: #999
                cursor: pointer
</style>


            


// WEBPACK FOOTER //
// src/components/pc/CaseInfo.vue